import buildAsyncCall from './asyncCall'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'

const Types = {
    DASHBOARD_DEVICES_ONLINE: {
        request: 'DASHBOARD_DEVICES_ONLINE##REQUEST',
        success: 'DASHBOARD_DEVICES_ONLINE##SUCCESS',
        failure: 'DASHBOARD_DEVICES_ONLINE##FAILURE',
    },
    DASHBOARD_DEVICES_TYPES: {
        request: 'DASHBOARD_DEVICES_TYPES##REQUEST',
        success: 'DASHBOARD_DEVICES_TYPES##SUCCESS',
        failure: 'DASHBOARD_DEVICES_TYPES##FAILURE',
    },
}

function fetchDevicesOnline() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/devices/online`,
        method: 'GET',
        types: [Types.DASHBOARD_DEVICES_ONLINE.request, Types.DASHBOARD_DEVICES_ONLINE.success, Types.DASHBOARD_DEVICES_ONLINE.failure],
    })
}

function fetchDevicesTypes() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/devices/types`,
        method: 'GET',
        types: [Types.DASHBOARD_DEVICES_TYPES.request, Types.DASHBOARD_DEVICES_TYPES.success, Types.DASHBOARD_DEVICES_TYPES.failure],
    })
}

export { Types, fetchDevicesOnline, fetchDevicesTypes }
